import React    from "react";
import './art.css';

const art = () => {
    return (
    <div class="artSection" id="collections">
<h1 class="collectionText">Collections</h1>
<div class="container collectionSection">
  <div class="collectionPassage">
    <p class="passageText">
    Every piece is 1 of 1, <br />
    Every collection is 1 of None
    </p>
  </div>
  <div class="row">
  </div>
</div>
    </div>
    )
}

export default art;
